import React from 'react';



export default function DropdownValue(props:any) {

    const option = props.option;

    if (!option) return null;

    const optionColor = _.get(option, 'color', null); //!_.isNil(option.color) ? option.color : null;

    const classes = Classes("ui5-txt-default fl-ac txt-truncate", props.className, {
        "m-t-4 m-b-4": !props.field.noDefaultPaddingMargin
    })

    if (optionColor) {

        const pillClasses = Classes(
            "ui5-pillbox s26",
            "gd-c-bgp-"+optionColor,
            "gd-c-pale-border-"+optionColor,
            props.className
        )

        return (
            <div className={classes}>
                <div className={pillClasses}>
                    {option.label}
                </div>
            </div>
        )
    }

    // no color
    return (
        <div className={classes}>
            {_.get(props.field.components, 'ValueIcon', false)}
            <span className="txt-truncate">{option.label}</span>
        </div>
    );



}
